(function () {
  var SELECTOR = '.pp-reveal';
  var observer = null;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function nodesIn(root) {
    var scope = root || document;
    var list = [];
    if (scope.matches && scope.matches(SELECTOR)) list.push(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll(SELECTOR).forEach(function (el) {
        list.push(el);
      });
    }
    return list;
  }

  function show(el) {
    el.classList.add('is-visible');
    if (observer) observer.unobserve(el);
  }

  function init(root) {
    var nodes = nodesIn(root);
    if (!nodes.length) return;

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      nodes.forEach(show);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          show(entry.target);
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    }

    nodes.forEach(function (el) {
      if (el.classList.contains('is-visible')) return;
      observer.observe(el);
    });
  }

  function boot() {
    document.documentElement.classList.add('js-reveal');
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!observer) return;
    nodesIn(event.target).forEach(function (el) {
      observer.unobserve(el);
    });
  });
})();
